/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'view-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M12.5 6C5.596 6 0 12.621 0 13.5S5.596 21 12.5 21 25 14.437 25 13.5 19.404 6 12.5 6zm0 11a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5z"/>'
  }
})
